import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import Item from './components/Item/index.js';
import ItemLink from './components/ItemLink.js';
import { ItemSeparator } from './components/ItemSeparator.js';
import { ItemsList } from './components/ItemsList/index.js';
import ItemSubLink from './components/ItemSubLink/index.js';
import { usePuzzleNavigationContext } from './context.js';
import { Wrapper } from './styled.js';
const PuzzleNav = ({ children, className, footer, header, companySelect, searchInput, timer, isCollapsedNav, collapseMainNav, mobileHeaderHeight, }) => {
    const providerValues = useMemo(() => ({
        isCollapsedNav,
        collapseMainNav,
    }), [isCollapsedNav, collapseMainNav]);
    return (_jsx(usePuzzleNavigationContext.Provider, { value: providerValues, children: _jsx(Wrapper, { className: className, $isCollapsedNav: isCollapsedNav, "data-testid": 'puzzle-nav-wrapper', children: _jsx(ItemsList, { header: header, companySelect: companySelect, searchInput: searchInput, timer: timer, footer: footer, mobileHeaderHeight: mobileHeaderHeight, children: children }) }) }));
};
const PuzzleNavMemo = memo(PuzzleNav);
const PuzzleNavWrapper = Object.assign(PuzzleNavMemo, {
    Item,
    ItemSubLink,
    ItemLink,
    ItemSeparator,
});
export default PuzzleNavWrapper;
